import $http from '../../axios';
import {Notification} from 'element-ui';
import * as MessageBox from 'element-ui';

//Obtener los tipos de comprobantes
export async function fetchDocuments({commit}) {
    commit('setMessageLoading', 'Obteniendo documentos');
    commit('setLoading', true);
    await $http.get('/api/documentos-finalizados-pendientes-por-enviar')
        .then((response) => {
            commit('setDocuments', response.data);
            commit('setLoading', false);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error al obtener los documentos',
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
            commit('setLoading', false);
        });
}

//Crear tipo de comprobante
export async function sendDocument({commit, dispatch}, document_id) {
    commit('setMessageLoading', 'Enviando documento');
    commit('setLoading', true);
    await $http.post('/api/enviar-documento-finalizado/' + document_id)
        .then((response) => {
            commit('setDocument', response.data.data);
            commit('setLoading', false);
            MessageBox.MessageBox.confirm('Documento emitido exitosamente', 'Exito', {
                confirmButtonText: 'Aceptar',
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
                type: 'success',
                customClass: 'notification-success'
            }).then(() => {
                commit('setShowPdf', true);
                dispatch('fetchDocuments');
            });
        })
        .catch((error) => {
            commit('setLoading', false);
            MessageBox.MessageBox.confirm(error.response.data.message, 'Error', {
                confirmButtonText: 'Aceptar',
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
                type: 'error',
                customClass: 'notification-error'
            });
        });
}

//Obtener los tipos de comprobantes
export async function updateCufeAndQr({commit, dispatch, state}) {
    commit('setMessageLoading', 'Actualizando documento');
    commit('setLoading', true);

    await $http.post('/api/actualizar-cufe-qr/' + state.selected_document.id, state.data)
        .then((response) => {
            Notification.success({
                title: 'Error!',
                message: 'Documento actualizado exitosamente',
                type: 'success',
                duration: 5000,
                customClass: 'notification-box',
            });
            dispatch('fetchDocuments');
            commit('setLoading', false);
            commit('setModalShow', false);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error al actualizar el documento',
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
            commit('setLoading', false);
        });
}

export async function downloadJson({}, document_data) {

   let prefix = '';

   if (document_data.prefix !== null){
       prefix = document_data.prefix.trim();
   }

   let name_file = prefix + document_data.consecutive + '.json';

    await $http({
        url: `/api/descargar-json/${document_data.id}`,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name_file);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });
    })
}



// WEBPACK FOOTER //
// ./src/modules/send_documents/actions.js